import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=1d7e241a&scoped=true"
import script from "./SupplierDetail.vue?vue&type=script&lang=ts"
export * from "./SupplierDetail.vue?vue&type=script&lang=ts"
import style0 from "./SupplierDetail.vue?vue&type=style&index=0&id=1d7e241a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e241a",
  null
  
)

export default component.exports